import { fetch } from '@atlassian/eoc-fetch';

import { type MyTeamsResponse } from './types';

export const getMyTeamsEndpoint = () => {
	return fetch<MyTeamsResponse>(`/v1/alerts/responders/suggested`);
};
